/**
 * Convert customer CSS for XML content
 */

import postcss from 'postcss'
import alter from 'postcss-alter-property-value'
import pxtorem from 'postcss-pxtorem'
import scopify from 'postcss-scopify'

export function process(css) {
  const absoluteFontSizes = alter({
    declarations: {
      'font-size': Object.entries({
        'xx-small': '9px',
        'x-small': '10px',
        small: '13px',
        medium: '16px',
        large: '18px',
        'x-large': '24px',
        'xx-large': '32px',
      }).map(([k, v]) => ({
        task: 'changeValue',
        to: v,
        whenValueEquals: k,
      })),
    },
  })

  return postcss()
    .use(absoluteFontSizes)
    .use(pxtorem())
    .use(scopify('.t-xmlcontent'))
    .process(css).css
}
